const callUserFunction = async (funcion, parametros = {}) => {
  const res = await fetch("/.netlify/functions/user", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ funcion, parametros })
  });

  const text = await res.text();

  if (!res.ok) {
    throw new Error("Error llamando función: " + funcion);
  }

  return text ? JSON.parse(text) : null;
};

export const addComentario = (idSeccion, idUsuario, texto) =>
  callUserFunction("addComentario", {
    0: idSeccion,
    1: idUsuario,
    2: texto
  });

export const addLike = (idSeccion, idUsuario) =>
  callUserFunction("addLike", {
    0: idSeccion,
    1: idUsuario
  });

export const deleteLike = (idSeccion, idUsuario) =>
  callUserFunction("deleteLike", {
    0: idSeccion,
    1: idUsuario
  });

export const deleteComentario = (idSeccion, idComentario) =>
  callUserFunction("deleteComentario", {
    0: idSeccion,
    1: idComentario
  });

export const getComentariosOfSeccion = (idSeccion) =>
  callUserFunction("getComentariosOfSeccion", {
    0: idSeccion
  });

export const getSeccionesFull = () =>
  callUserFunction("getSeccionesFull");

export const getsertUsuario = (id, nombre = null) =>
  callUserFunction("getsertUsuario", {
    0: id,
    1: nombre
  });

export const updateNombreUsuario = (idUsuario, nombre) =>
  callUserFunction("updateNombreUsuario", {
    0: idUsuario,
    1: nombre
  });